import { useQuery } from "@tanstack/react-query";
import { getHotelRoomCategoriesForSelect } from "../../api/apiHotelRoomCategories";
import i18next from "i18next";

const useGetHotelRoomCategoriesForSelect = () => {
    const { data, error, isLoading } = useQuery({
        queryKey: ["HotelRoomCategoriesForSelect", i18next.language],
        queryFn: getHotelRoomCategoriesForSelect,
        staleTime: 1000 * 60 * 30,
    });

    return {
        options: data?.data || [],
        error,
        isLoading,
    };
};

export default useGetHotelRoomCategoriesForSelect;
